<template>
  <svg width="22" height="16" viewBox="0 0 22 16" xmlns="http://www.w3.org/2000/svg">
    <g stroke="#ADADAD" fill="none" fill-rule="evenodd" stroke-linecap="square">
      <path
        d="M1 15.07v-1.28V9.5a2 2 0 012-2h16a2 2 0 012 2v5.151M3 5.578s0 0 0 0V3c0-1.105.716-2 1.6-2h12.8c.884 0 1.6.895 1.6 2v2.578"
      />
      <path
        d="M5.5 5.5V4.028c0-.291.18-.528.4-.528h3.2c.22 0 .4.237.4.528V5.5M12.5 5.5V4.028c0-.291.18-.528.4-.528h3.2c.22 0 .4.237.4.528V5.5M1.5 13h19"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconBeds',
};
</script>

<style></style>
